import { render } from "./museumTechnology.vue?vue&type=template&id=1b152202"
import script from "./museumTechnology.vue?vue&type=script&lang=js"
export * from "./museumTechnology.vue?vue&type=script&lang=js"

import "./museumTechnology.vue?vue&type=style&index=0&id=1b152202&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__